import * as React from "react";
const SvgArrow1Up = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path fill="none" d="M0 0h24v24H0z" /><path d="m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8z" /></svg>;
export { SvgArrow1Up as ReactComponent };